import { useState } from "react";
import { Box, Link } from "@mui/material";
import { normalizeText } from "./htmlUtils";

export function UpcomingDeadlinesCell({ text }: { text?: string | null }) {
  const [expanded, setExpanded] = useState(false);
  const [overflow, setOverflow] = useState(false);
  const raw = normalizeText(text);
  const isEmpty = !raw.trim() || raw.trim().toLowerCase() === "n/a";

  if (isEmpty) {
    return <>—</>;
  }

  return (
    <Box>
      <Box
        ref={(el: HTMLDivElement | null) => {
          if (!el || expanded) return;
          const isOverflowing = el.scrollHeight > el.clientHeight + 1;
          setOverflow((prev) => (prev === isOverflowing ? prev : isOverflowing));
        }}
        sx={
          expanded
            ? { whiteSpace: "pre-wrap", wordBreak: "break-word" }
            : {
                display: "-webkit-box",
                WebkitBoxOrient: "vertical",
                WebkitLineClamp: 3,
                overflow: "hidden",
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
              }
        }
      >
        {raw}
      </Box>
      {overflow && (
        <Link
          component="button"
          type="button"
          variant="caption"
          onClick={() => setExpanded((prev) => !prev)}
          sx={{ mt: 0.5, display: "inline-block" }}
        >
          {expanded ? "Show less" : "Show more"}
        </Link>
      )}
    </Box>
  );
}
